export default __webpack_public_path__ + "static/media/jeffrey-wright_0.13a4ba54.jpg";